import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import ButtonSwitchMulti from '../../components/actions/ButtonSwitchMulti';
import { actualityAggregatedStatsViewMode } from '../store/actuality.kpi.state';

const ActualityViewModeToggle: React.FC = () => {
  const { t } = useTranslation('feed');
  const [viewMode, setViewMode] = useRecoilState(
    actualityAggregatedStatsViewMode,
  );

  const viewModeOptions = [{ label: t('Summary') }, { label: t('Details') }];
  // const viewModeOptions = [{ label: t('Totals') }, { label: t('Items') }];

  return (
    <div
      className={classNames(
        'flex w-full items-center justify-center',
        'p-2',
        // 'bg-app-panel-light/40',
        // 'saturate-120 backdrop-blur',
        'sticky top-0',
        'z-header_screen',
      )}
    >
      <ButtonSwitchMulti
        buttonType="secondary"
        autoSize
        className="w-full bg-transparent text-xs"
        options={viewModeOptions}
        selectedIndex={viewMode === 'summary' ? 0 : 1}
        onClick={index => setViewMode(index === 0 ? 'summary' : 'details')}
      />
    </div>
  );
};

export default ActualityViewModeToggle;
